import { GetterTree, StoreOptions } from 'vuex';
import smh from '@/renderer/scripts/smh';
import * as CollaborateGroupEvents from './events';

// 核心参数
export interface CollaborateGroupCoreInfo {
  id: number; // 协作空间id
  spaceOrgId: number; // 协作空间对应群主的 orgId
}
// 群组信息
export interface CollaborateGroupBaseInfo extends CollaborateGroupCoreInfo {
  spaceId: string;
  name: string;
}
type CollaborateGroupOwnerInfo = {
  id: number;
  orgId: number;
  nickname: string;
  avatar: string;
  isExternal: boolean;
};
export interface CollaborateGroupState {
  baseInfo: CollaborateGroupBaseInfo;
  owner: CollaborateGroupOwnerInfo;
}
const defaultBaseInfo = {
  id: 0,
  spaceId: '',
  name: '',
  spaceOrgId: 0,
};
const defaultOwner = {
  id: 0,
  orgId: 0,
  nickname: '',
  avatar: '',
  isExternal: false,
};
const collaborateGroup: StoreOptions<CollaborateGroupState> = {
  state: {
    baseInfo: defaultBaseInfo,
    owner: defaultOwner,
  },
  mutations: {
    // 重置初始化
    [CollaborateGroupEvents.CLEAR_DATA](state: CollaborateGroupState) {
      state.baseInfo = defaultBaseInfo;
      state.owner = defaultOwner;
    },
    // 设置 baseInfo
    [CollaborateGroupEvents.SET_BASE_INFO](state: CollaborateGroupState, baseInfo: CollaborateGroupBaseInfo) {
      state.baseInfo = baseInfo;
    },
    // 设置 owner
    [CollaborateGroupEvents.SET_OWNER_INFO](state: CollaborateGroupState, ownerInfo: CollaborateGroupOwnerInfo) {
      state.owner = ownerInfo;
    },
  },
  getters: {
    // 是否是群组管理员
    groupAdmin: (
      state: CollaborateGroupState,
      getters: GetterTree<CollaborateGroupState, any>,
      rootState,
      rootGetters,
    ): boolean => {
      if (state.owner.id === 0) {
        return false;
      }
      const { userId } = rootGetters.userBaseInfo;
      const { orgId } = rootGetters;
      return state.owner.id === userId && state.owner.orgId === orgId;
    },
    // 1. 企业版/团队版发起的协作空间，允许包含外部成员时，
    //    1.1 群主&内部成员视角： 群组标识为【外部共享】
    //    1.2 外部成员视角：     创建者的公司名 【xx公司】
    // 2. 个人版创建的群组
    //   1.1 群主视角： 只有群主一个人【内部共享】/有其他人加入【外部共享】
    //  TODO接口暂不支持，暂不实现这个属性
    // groupTag: (): string => {
    //   return '';
    // },
    //  当前用户是否与群主在同一个企业
    sameEnterprise: (
      state: CollaborateGroupState,
      getters: GetterTree<CollaborateGroupState, any>,
      rootState,
      rootGetters,
    ): boolean | undefined => {
      if (state.owner.orgId === 0) {
        return void 0;
      }
      return state.owner.orgId === rootGetters.orgId;
    },
  },
  actions: {
    async [CollaborateGroupEvents.GET_GROUP_INFO](context, coreInfo: CollaborateGroupCoreInfo) {
      context.commit(CollaborateGroupEvents.CLEAR_DATA);
      const { data } = await smh.userAPI.getCollaborationSpaceInfo({
        groupId: coreInfo.id,
        spaceOrgId: coreInfo.spaceOrgId,
      });
      context.commit(CollaborateGroupEvents.SET_OWNER_INFO, data.owner);
      context.commit(CollaborateGroupEvents.SET_BASE_INFO, {
        id: data.id,
        name: data.name,
        spaceId: data.spaceId,
        spaceOrgId: data.orgId,
      });
    },
  },
};
export default collaborateGroup;
